export default {
    base: '320px',
    sm: '600px',
    md: '768px',
    lg: '1024px',
    xl: '1366px',
    '2xl': '1920px'
}
